export const waitForNextPaint = () =>
  new Promise<number>((resolve) => {
    requestAnimationFrame((t1) => requestAnimationFrame((t2) => resolve(t1 + t2)));
  });
